import { createAuthClient } from 'better-auth/react';
import { emailOTPClient, organizationClient, twoFactorClient } from 'better-auth/client/plugins';

export const authClient = createAuthClient({
    baseURL: window.location.origin,
    basePath: '/api/auth',
    plugins: [organizationClient(), emailOTPClient(), twoFactorClient()],
});
